import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faAngleDown,
  // faAngleRight,
  // faArrowRight,
  faCertificate,
  faCloudArrowDown,
} from "@fortawesome/free-solid-svg-icons";
// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
// import { faCommentDots } from "@fortawesome/free-regular-svg-icons";
// import { useSelector } from "react-redux";
// import {
//   englishUser,
//   sinhalaUser,
//   tamilUser,
// } from "../../dummyData/academyData";
// import LanguageDropDown from "../../Components/LanguageDropDown/LanguageDropDown";
// import onlineClassImg from "../../assets/AdsBanners/online-class-academy.png";
// import trainerImg from "../../assets/AdsBanners/trainer-banner-academy.png";
import "./AcademyDetails.css";

function AcademyDetails() {
  // const selectedLanguage = useSelector((state) => state.language.language);
  // const [expanded, setExpanded] = useState(null);
  // const [language, setLanguage] = useState(sinhalaUser);

  // useEffect(() => {
  //   const hash = window.location.hash?.replace("#", "");
  //   if (hash) {
  //     setExpanded(hash);

  //     setTimeout(() => {
  //       const section = document.getElementById(hash);
  //       section?.scrollIntoView({ behavior: "smooth" });
  //     }, 100);
  //   }
  // }, []);

  // useEffect(() => {
  //   switch (selectedLanguage.value) {
  //     case "english":
  //       setLanguage(englishUser);
  //       break;
  //     case "tamil":
  //       setLanguage(tamilUser);
  //       break;
  //     default:
  //       setLanguage(sinhalaUser);
  //       break;
  //   }
  // }, [selectedLanguage]);

  // const toggleSection = (sectionId) => {
  //   setExpanded((prev) => (prev === sectionId ? null : sectionId));
  //   if (sectionId !== expanded) {
  //     window.history.pushState(null, null, `/academy-details/${sectionId}`);
  //   }
  // };
  return (
    <div>
      <div className="container-fluid px-0 h-100 top-height-academy-details pb-5">
        {/* Header Section */}
        <header className="academy-header text-center mb-4">
          <h1 className="academy-title display-5 fw-bold mb-3">
            SLDL <span className="text-warning">Academy</span>
          </h1>
          {/* <div className="language-selector d-flex justify-content-end mb-3">
            <LanguageDropDown />
          </div> */}
        </header>

        <section
          id="online-class"
          className="container academy-section w-100 pb-3"
          // onClick={() => navigate("https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldlpro&hl=en")}
        >
          <div>
            <h1 className={`acdmy-section-header text-start`}>
              රියදුරු විභාගය පළමු සැරයෙන්ම සමත් වෙන්න
            </h1>

            <span className="text-danger">
              දේශක : T.M. සෝමරත්න (රජයේ ලියාපදිංචි ප්‍රවීණ දේශක, 25+ වසරක
              පළපුරුද්ද) පවත්වන.
            </span>
            <br />
            <br />

            <div className="d-flex justify-content-center align-content-center">
              <FontAwesomeIcon
                icon={faCertificate}
                color="red"
                size={"3x"}
                spin={true}
              />
              <span
                className="snap-promotion"
                style={{ marginLeft: "12px", fontSize: "28px" }}
              >
                40% off
              </span>
            </div>

            <br />
            <ul>
              <li>
                <span className="text-primary">
                  {" "}
                  <strong>
                    අගෝස්තු 4 සිට 8 දක්වා විභාගය සදහාම පැවැත්වන දේශනයට සහභාගී
                    වීමට
                  </strong>{" "}
                </span>
              </li>
            </ul>
            <span>Pro App (පටිගත පාඩම්) – (ගාස්තුව Rs. 350)</span>
            <br />
            <span>පාඩම් මාලාවේ අන්තර්ගතය</span>
            <div>
              <ul>
                <li>අනුමාන ප්‍රශ්න සාකච්ඡාව.</li>
                <li>ප්‍රශ්න පත්‍රයට ඉදිරිපත් වන ආකාරය විස්තර කිරීම.</li>
                <li>මාර්ග සංඥා පැහැදිලි කිරීම.</li>
                <li>මාර්ග නීති සහ රීති පැහැදිලි කිරීම.</li>
                <li>ප්‍රයෝගික පරීක්ෂණය සදහා උපදෙස්.</li>
                <li>විනය ගරුක රියදුරෙක් සතු ගුණාංග පැහැදිලි කිරීම්.</li>
              </ul>
            </div>
            <span>ඕනෑම වෙලාවක නැරඹීමේ පහසුකම</span>
            <br />

            <span>අනුමාන ප්‍රශ්නපත්‍ර, සටහන්, ප්‍රායෝගික උපදෙස්</span>
            <br />

            <span>
              App Store හෝ Play Store වෙතින්{" "}
              <strong className="text-warning">
                “රියදුරු විභාග පිළිතුරු - PRO”{" "}
              </strong>
              ලෙස සෙවීමෙන් ලබාගන්න
            </span>
            <br />
            <a
              href="https://play.google.com/store/apps/details?id=appinventor.aimechsita.sldlpro"
              className="btn whatsapp-btn whatsapp-btn-alt mt-3 mb-3"
              style={{ textDecoration: "none" }}
            >
              <FontAwesomeIcon icon={faCloudArrowDown} className="me-2" />
              Download Now
            </a>

            <hr />
            <br />
            <ul>
              <li>
                <span className="text-primary">
                  {" "}
                  සජීවී Online පන්තිය – (ගාස්තුව Rs. 1,000){" "}
                </span>
              </li>
            </ul>
            <span>Zoom හරහා සජීවී දේශන</span>
            <br />

            <span>ප්‍රශ්නපත්‍ර පුහුණු සහ Q&A සජීවීව</span>
            <br />

            <span>
              ආසන සීමිතයි—WhatsApp (071-2367846) අංකයට "LIVE CLASS" ලෙස අදම
              පණිවිඩයක් යවන්න
            </span>
          </div>
        </section>

        {/* Online Class Section */}
        {/* <section
          id="online-class"
          className="container academy-section w-100 pb-3"
        >
          <div>
            <h4
              className={`acdmy-section-header text-start ${
                expanded === "online-class" ? "fw-bold text-primary" : "fw-bold"
              }`}
              onClick={() => toggleSection("online-class")}
            >
              {expanded === "online-class" ? (
                <FontAwesomeIcon
                  icon={faAngleDown}
                  className="pe-2"
                  color="#4267B2"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faAngleRight}
                  className="pe-2"
                  color="#4267B2"
                />
              )}
              {language.onlineClass.title}
            </h4>
            {expanded !== "online-class" && (
              <img
                src={onlineClassImg}
                alt="Online Class driving exam preparation"
                style={{ width: "100%", height: "auto" }}
                className="img-fluid driving-school-card-image"
              />
            )}
          </div>

          {expanded === "online-class" && (
            <div className="acdmy-section-content">
              <h4 className="mt-3 text-start fw-bold">
                {language.onlineClass.expandedTitle}
              </h4>

              <p className="text-start mt-3">
                {language.onlineClass.description}
              </p>

              <h5 className="mt-4">{language.onlineClass.syllabusTitle}</h5>
              <ul className="text-start d-inline-block acdmy-content-text">
                {language.onlineClass.syllabus.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <p className="mt-3 acdmy-content-text">
                <strong>{language.onlineClass.scheduleText}</strong>{" "}
                {language.onlineClass.schedule.join(", ")}
              </p>

              <p className="mt-2 acdmy-content-text">
                <strong>{language.onlineClass.timeText}</strong>{" "}
                {language.onlineClass.time}
              </p>

              <p className="mt-2 acdmy-content-text">
                <strong>{language.onlineClass.feeText}</strong>{" "}
                {language.onlineClass.fee}
              </p>

              <p className="mt-3 acdmy-content-text">
                {language.onlineClass.interestQuestion}
              </p>

              <p className="mt-2 acdmy-content-text">
                {language.onlineClass.contact}{" "}
                {language.onlineClass.num.map((number, index) => (
                  <span key={index}>
                    <a href={`tel:${number}`}>{number}</a>{" "}
                    {index === 0 ? <span>| </span> : ""}
                  </span>
                ))}
              </p>

              <p className="mt-3 acdmy-content-text">
                {language.onlineClass.finalDescription}
              </p>

              <a
                href={language.onlineClass.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn whatsapp-btn-alt mt-3 mb-3"
              >
                <span className="whatsapp-icon">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </span>

                {language.onlineClass.whatsappButton}

                <span className="whatsapp-hover">
                  <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </a>
            </div>
          )}
          {expanded === "online-class" && (
            <img
              src={onlineClassImg}
              alt="Online Class driving exam preparation"
              style={{ width: "100%", height: "auto" }}
              className="img-fluid driving-school-card-image"
            />
          )}
        </section> */}

        {/* Personal Driving Instructor Section */}
        {/* <section
          id="personal-driving-instructor"
          className="container academy-section w-100 mt-5 pb-3"
          style={{ cursor: "pointer" }}
        >
          <div className="">
            <h3
              className={`acdmy-section-header text-start ${
                expanded === "personal-driving-instructor"
                  ? "fw-bold text-primary"
                  : "fw-bold"
              }`}
              onClick={() => toggleSection("personal-driving-instructor")}
            >
              {expanded === "personal-driving-instructor" ? (
                <FontAwesomeIcon
                  icon={faAngleDown}
                  size="x"
                  color="#4267B2"
                  className="pe-2"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faAngleRight}
                  size="x"
                  color="#4267B2"
                  className="pe-2"
                />
              )}{" "}
              {language.personalInstructor.title}
            </h3>
            {expanded !== "personal-driving-instructor" && (
              <img
                src={trainerImg}
                alt="Personal Driving Instructor to learn driving"
                style={{ width: "100%", height: "auto" }}
                className="img-fluid driving-school-card-image"
              />
            )}
          </div>
          {expanded === "personal-driving-instructor" && (
            <div className="acdmy-section-content">
              <h5 className="mt-3 text-start fw-bold">
                {language.personalInstructor.question}
              </h5>
              <p className="mt-3 acdmy-content-text">
                {language.personalInstructor.description}
              </p>
              <h5 className="mt-4 text-start">
                {language.personalInstructor.listTitle}
              </h5>
              <ul className="text-start d-inline-block acdmy-content-text">
                {language.personalInstructor.serviceList.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <p className="acdmy-content-text">
                {language.personalInstructor.prompt}
              </p>
              <a
                href="https://wa.me/94712367846?text=I%20am%20looking%20for%20a%20personal%20driving%20instructor."
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn whatsapp-btn-alt mt-3 mb-3"
              >
                <span className="whatsapp-icon">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </span>

                {language.personalInstructor.whatsappButton}

                <span className="whatsapp-pulse">
                  <FontAwesomeIcon icon={faCommentDots} />
                </span>
              </a>
            </div>
          )}
          {expanded === "personal-driving-instructor" && (
            <img
              src={trainerImg}
              alt="Personal Driving Instructor to learn driving"
              style={{ width: "100%", height: "auto" }}
              className="img-fluid driving-school-card-image"
            />
          )}
        </section> */}
      </div>
    </div>
  );
}

export default AcademyDetails;
